import { gql } from "@outschool/ui-apollo";

import {
  ActivityListingFragment,
  ListingCardFragment,
} from "../../Listings/graphql/fragments";

export default gql`
  query SearchListings(
    $searchFilters: SearchFilters!
    $offset: Int
    $limit: Int
    $cursor: String
    $skipRating: Boolean!
    $matchNames: Boolean
    $referrer: String
    $includeMatchingSections: Boolean
    $source: Boolean
    $anonymousId: String
    # Each search has a unique search UID. This parameter is used to send an override from the client, specifying the search UID to use for the search.
    # If not provided, a search UID is generated by the backend.
    $searchUid: String
    $pageImpressionId: String
    $isFuzzySearchEnabled: Boolean
    $pageLocation: String
    $useCase: SearchUseCase
    $disableAutoApplyFilterTypes: [AutoAppliedFilterType]
    $learnerPlanGoalUid: String
    $withRecentReviews: Boolean!
  ) {
    searchListings(
      searchFilters: $searchFilters
      cursor: $cursor
      offset: $offset
      limit: $limit
      matchNames: $matchNames
      referrer: $referrer
      includeMatchingSections: $includeMatchingSections
      source: $source
      anonymousId: $anonymousId
      searchUid: $searchUid
      pageImpressionId: $pageImpressionId
      isFuzzySearchEnabled: $isFuzzySearchEnabled
      pageLocation: $pageLocation
      useCase: $useCase
      disableAutoApplyFilterTypes: $disableAutoApplyFilterTypes
      learnerPlanGoalUid: $learnerPlanGoalUid
    ) {
      cursor
      total
      listings {
        ...ActivityListing_listing
        ...ListingCard_listing
        isAvailable
        isIncludedWithMembership
        insertionId
      }
      autoAppliedFilters {
        gradeLevels
      }
      # Returns the search UID used for the search, either the override provided in the query parameters or a generated one by the backend.
      searchUid
    }
  }
  ${ActivityListingFragment}
  ${ListingCardFragment}
`;
